import { createSelector } from 'reselect';
import { RootState } from 'lib/centralStore';

const _self = (state: RootState) => state.myBets;

export const selectIdsRealTimeCashout = createSelector([_self], ({ idsRealTimeCashout }) => idsRealTimeCashout);
export const selectSelectedBet = createSelector([_self], ({ selectedBet }) => selectedBet);
